import React from 'react';

/**
 * PremiumCard - Carte avec effet glass premium
 * Réutilisable pour sons, playlists, radios, etc.
 */
const PremiumCard = ({ 
  children, 
  onClick,
  className = '',
  hoverable = true,
  style = {} 
}) => {
  return (
    <div
      onClick={onClick}
      className={`
        bg-white/[0.06] 
        backdrop-blur-xl 
        border border-white/[0.08] 
        rounded-2xl 
        p-3 md:p-4 
        transition-all 
        duration-300
        ${hoverable ? 'hover:bg-white/10 hover:border-purple-500/30 active:scale-98 cursor-pointer' : ''}
        ${className}
      `}
      style={{
        boxShadow: '0 0 25px rgba(106, 79, 255, 0.15)',
        ...style
      }}
    >
      {children}
    </div>
  );
};

export default PremiumCard;
